import {
  DROPBOX_APP_KEY,
  GOOGLE_DRIVE_API_KEY,
  GOOGLE_DRIVE_APP_ID,
  GOOGLE_DRIVE_CLIENT_ID,
  ONEDRIVE_APP_ID,
  ONEDRIVE_AUTHORITY
} from './config';
import { createDropboxPicker } from './dropboxPicker';
import { createGoogleDrivePicker } from './googleDrivePicker';
import { createOneDrivePicker } from './oneDrivePicker';
import type { CloudPickerAdapter, CloudPickerProvider } from './types';

export const CLOUD_PICKERS: Record<CloudPickerProvider, CloudPickerAdapter> = {
  dropbox: createDropboxPicker({
    appKey: DROPBOX_APP_KEY
  }),
  onedrive: createOneDrivePicker({
    appId: ONEDRIVE_APP_ID,
    authority: ONEDRIVE_AUTHORITY
  }),
  google_drive: createGoogleDrivePicker({
    apiKey: GOOGLE_DRIVE_API_KEY,
    clientId: GOOGLE_DRIVE_CLIENT_ID,
    appId: GOOGLE_DRIVE_APP_ID
  })
};
